<template>
  <wz-card title="Dominios de correo de la empresa">
    <p class="text-muted text-sm mb-2">
      Con ellos se reconoce un correo de la empresa. Ese correo no sirve para entrar al portal ni para firmar, porque alguien
      más puede leerlo.
    </p>
    <wz-alert v-if="loaded && !configured" variant="warning" class="mb-2">
      <strong>Falta configurar esto.</strong> Hasta entonces, los colaboradores de esta empresa no pueden usar el portal ni firmar.
    </wz-alert>
    <wz-input v-model="domains" label="Dominios, separados por coma" placeholder="miempresa.com, miempresa.pe" :disabled="noDomain" />
    <div class="mt-2">
      <wz-checkbox v-model="noDomain">Esta empresa no tiene dominio de correo propio</wz-checkbox>
    </div>
    <div class="flex justify-end mt-2">
      <wz-button variant="primary" :disabled="!noDomain && !parsed.length" @click="save">Guardar</wz-button>
    </div>
  </wz-card>
</template>

<script>
import CompanyService from '@/core/services/CompanyService'
import { Alert } from '@wizepe/wizeui'

export default {
  name: 'CompanyEmailDomains',
  props: {
    companyId: { type: Number, required: true },
  },
  data() {
    return {
      loaded: false,
      configured: false,
      domains: '',
      noDomain: false,
    }
  },
  computed: {
    parsed() {
      return (this.domains || '').split(',').map(d => d.trim()).filter(Boolean)
    },
  },
  async created() {
    try {
      const payload = (await CompanyService.get(this.companyId)).payload || {}
      // null: nunca se configuró. Vacío: la empresa declaró que no tiene dominio propio.
      const value = payload.emailDomains
      this.configured = value !== null && value !== undefined
      this.noDomain = value === ''
      this.domains = value ? value.split(',').join(', ') : ''
      this.loaded = true
    } catch (e) {
      Alert.error(e.errors ? e.errors.message : 'Error al cargar los dominios')
    }
  },
  methods: {
    async save() {
      try {
        await CompanyService.saveEmailDomains(this.companyId, this.noDomain ? [] : this.parsed)
        this.configured = true
        if (this.noDomain) this.domains = ''
        Alert.success('Dominios guardados')
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al guardar los dominios')
      }
    },
  },
}
</script>
